import axios from 'axios';

// console.log("api.ts: Creating axios instance");

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 30000,
});

// console.log("api.ts: Setting up request interceptor");

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    // console.log("api.ts: Request interceptor - processing request to:", config.url);
    const token = localStorage.getItem('accessToken');
    if (token) {
      // console.log("api.ts: Request interceptor - adding auth token to request");
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      // console.log("api.ts: Request interceptor - no auth token found");
    }
    // console.log("api.ts: Request interceptor - final config:", {
    //   url: config.url,
    //   method: config.method,
    //   headers: config.headers,
    //   data: config.data
    // });
    return config;
  },
  (error) => {
    console.error("api.ts: Request interceptor error:", error);
    return Promise.reject(error);
  }
);

// console.log("api.ts: Setting up response interceptor");

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => {
    // console.log("api.ts: Response interceptor - successful response from:", response.config.url);
    // console.log("api.ts: Response interceptor - response data:", response.data);
    return response;
  },
  async (error) => {
    console.error("api.ts: Response interceptor - error occurred:", error);
    console.error("api.ts: Response interceptor - error response:", error.response);
    
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      // console.log("api.ts: Response interceptor - 401 error, attempting token refresh");
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem('refreshToken');
        if (refreshToken) {
          // console.log("api.ts: Response interceptor - attempting to refresh token");
          // Use bare axios (not `api`) so this call skips the request/response
          // interceptors — that avoids a refresh->401->refresh loop and sending a
          // stale Authorization header. But it must still hit the API origin, so
          // prepend the same baseURL the `api` instance uses.
          const response = await axios.post(
            `${process.env.REACT_APP_API_BASE_URL || ''}/api/auth/refresh`,
            { refreshToken }
          );

          const { accessToken } = response.data;
          // console.log("api.ts: Response interceptor - token refresh successful");
          localStorage.setItem('accessToken', accessToken);
          
          // Retry the original request
          // console.log("api.ts: Response interceptor - retrying original request");
          return api(originalRequest);
        } else {
          // console.log("api.ts: Response interceptor - no refresh token available");
        }
      } catch (refreshError) {
        // console.error("api.ts: Response interceptor - token refresh failed:", refreshError);
        // to login or handle refresh failure
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        // console.log("api.ts: Response interceptor - tokens cleared, redirecting to login");
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);

// console.log("api.ts: Axios instance configured and ready");

export default api;